import React from 'react';
import clsx from 'clsx'

const SwipeMe = ({active}) => {
    return <div className={clsx("swipe-me", active ? "active":"")}><b>SWIPE ME</b><span></span></div>
}
export default SwipeMe